import { styled } from "styled-components";

export const LinkReadStyle = styled.div`
  .read-more-btn {
    p {
      padding: var(--size05) 0 0 0;
      margin: 0;
      font-family: "DIN Pro Medium";
    }
  }
  .read-more .big-ellipsis {
    /* height: ${(props) =>
      props.readMore
        ? ""
        : "calc((var(--p-small) * 5) + var(--line-height-p-small) * 2)"};
    overflow: hidden; */
    p {
      display: ${(props) => (props.readmore ? "block" : "-webkit-box")};
      overflow: hidden;
      -webkit-box-orient: vertical;
    }
  }

  @media (max-width: 900px) {
    /* .read-more {
      height: ${(props) => (props.readmore ? "" : "16.1vw")};
    } */
  }
`;
